import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentLayoutBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { EntityOverviewLayout } from './EntityOverviewLayout';

/**
 * Per-user flag, toggled at `/settings/feature-flags`. Off by default, and
 * evaluated once while the extension tree is built - turning it on or off
 * takes a page reload.
 */
export const TWO_COLUMN_OVERVIEW_FLAG = 'entity-overview-two-column';

/**
 * Replaces the built-in overview layout for every entity, when the flag above
 * is on. The catalog picks the first layout whose filter matches and falls
 * back to its own, so an unfiltered layout here wins outright - and a layout
 * whose `if` predicate fails is never registered at all, which is what makes
 * the flag a clean toggle between this layout and the built-in one.
 *
 * The predicate sits on the extension rather than on the module so that
 * anything else this module grows later is gated on its own terms.
 */
const entityOverviewLayout = EntityContentLayoutBlueprint.make({
  name: 'two-column',
  if: { featureFlags: { $contains: TWO_COLUMN_OVERVIEW_FLAG } },
  params: {
    loader: async () => EntityOverviewLayout,
  },
});

export const catalogModule = createFrontendModule({
  pluginId: 'catalog',
  featureFlags: [
    {
      name: TWO_COLUMN_OVERVIEW_FLAG,
      description:
        'Lay the entity overview out as a metadata rail beside a grid of equal-height data cards, instead of the built-in layout',
    },
  ],
  extensions: [entityOverviewLayout],
});
